import component from './cancelButton';

export default component;